import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CourtSystemUser } from '@ftr/contracts/api/court-system'
import { Uuid } from '@ftr/contracts/type/shared'
import {
  ButtonColor,
  ButtonSize,
  NotificationDisplayType,
  NotificationService,
  NotificationType,
} from '@ftr/foundation'
import { Store } from '@ngxs/store'
import { UserGroupService } from '../../services'
import { GetInitialCurrentUserGroupsAction } from '../../store'

@Component({
  selector: 'ftr-user-profile-groups-list',
  templateUrl: './user-profile-groups-list.component.html',
  styleUrls: ['./user-profile-groups-list.component.css'],
})
export class UserProfileGroupsListComponent {
  @Input() courtSystemUser: CourtSystemUser
  @Output() onSave = new EventEmitter()

  readonly buttonColor = ButtonColor
  readonly buttonSize = ButtonSize

  constructor(
    private readonly store: Store,
    private readonly userGroupService: UserGroupService,
    private readonly notificationService: NotificationService,
  ) {}

  removeMember(userGroupId: Uuid, userId: Uuid, userGroupName: string): void {
    this.notificationService.clear()
    this.userGroupService.removeMembers(userGroupId, { userIds: [userId] }).subscribe(remote => {
      if (remote.isSuccess()) {
        this.onSave.emit()
        this.store.dispatch(new GetInitialCurrentUserGroupsAction())
        this.notificationService.showSuccessNow(`User was successfully removed from ${userGroupName}.`)
      } else if (remote.isFailure()) {
        this.notificationService.show(NotificationDisplayType.Now, {
          type: NotificationType.Error,
          message: remote.error?.message || `An error occurred while being removed from ${userGroupName}.`,
        })
      }
    })
  }
}
